




















import { Component, Prop, Vue } from 'vue-property-decorator'
import { CardState } from '@/dynamic-tech-task/types'


@Component({})
export default class TechTaskCard extends Vue {
    @Prop() title !: string
    @Prop({ default: false }) disableButton !: boolean
    @Prop({ default: true }) displayActions !: boolean
    @Prop({ default: false }) loading !: boolean

    get cardError(): boolean {
        return this.$store.state.techTask.cardState === CardState.ERROR
    }
}
